import config from 'src/globals';
import AuthHelper from '../../auth/auth-helper';

const { ANALYTICS_FRONTEND_BASE_URL } = config;
export interface IAppMetadataInfo {
    iframeId: string;
    origin: string;
    url: string;
    passCredentials?: boolean;
    basePath: string;
}

interface IAppMetaData {
    [x: string]: IAppMetadataInfo;
}
export enum IframeApps {
    Analytics = 'GENERIC_ANALYTICS',
}
export type IFrameApp = 'TransporterPortal';
const authHeaders = AuthHelper.getAuthenticationHeaders();

export const AppMetadata: IAppMetaData = {
    [IframeApps.Analytics]: {
        iframeId: 'persistent-iframe-generic-analytics',
        origin: `https://${authHeaders['organisation-id']}.${ANALYTICS_FRONTEND_BASE_URL}`,
        url: `https://${authHeaders['organisation-id']}.${ANALYTICS_FRONTEND_BASE_URL}`,
        basePath: '/analytics',
        passCredentials: true,
    },
};

export enum OutgoingActions {
    Routing = 'ROUTING',
    CREDENTIALS_SHARING = 'CREDENTIALS_SHARING',
}
